import * as React from 'react';
import type { SVGProps } from 'react';

const IconCloud = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="15" fill="none" {...props}>
    <path
      stroke="currentColor"
      d="M4.588 11.67v2.073c0 .146.143.236.26.167l4.52-2.226a.535.535 0 0 1 .236-.056h1.174c2.694 0 5.042-2.163 5.218-5.014.19-3.127-2.14-5.735-5.042-5.735H6.062C3.263.88 1 3.286 1 6.254c0 2.33 1.396 4.313 3.346 5.055a.378.378 0 0 1 .242.354v.007Z"
    />
  </svg>
);
export default IconCloud;
